import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// import * as Sentry from '@sentry/angular';

// Sentry.init({
//     dsn: 'https://d8ad51c02592e24e848d1767d70042b0@o4507732196327424.ingest.us.sentry.io/4507946835705856',
//     integrations: [
//         // Registers and configures the Tracing integration,
//         // which automatically instruments your application to monitor its
//         // performance, including custom Angular routing instrumentation
//         Sentry.browserTracingIntegration(),
//         // Registers the Replay integration,
//         // which automatically captures Session Replays
//         Sentry.replayIntegration(),
//     ],

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for tracing.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 0.5,

//     // Capture Replay for 10% of all sessions,
//     // plus for 100% of sessions with an error
//     replaysSessionSampleRate: 0,
//     replaysOnErrorSampleRate: 0.1,
//     enabled: false,
// });

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    //eslint-disable-next-line
    .catch((err) => console.error(err));
